/**
 * Resolves which quote tab should be open based on sessionStorage and current tabs.
 * @param {Array<{ IdQuoteTabs: string }>|null|undefined} Tabs
 * @returns {string|null}
 */
export function resolveOpenQuoteTabId(Tabs) {
	if (!Tabs?.length) {
		return null;
	}
	const open_tab = sessionStorage.getItem("cpq_open_tab");
	if (open_tab === null) {
		return Tabs[0].IdQuoteTabs;
	}
	const matchedTab = Tabs.find((tab) => tab.IdQuoteTabs == open_tab);
	if (matchedTab === undefined) {
		return Tabs[0].IdQuoteTabs;
	}

	return matchedTab.IdQuoteTabs;
}
